import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c4950e92&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c4950e92&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4950e92')) {
      api.createRecord('c4950e92', component.options)
    } else {
      api.reload('c4950e92', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c4950e92&lang=pug", function () {
      api.rerender('c4950e92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/news/collaboration-with-caves-education/index.vue"
export default component.exports